import React from 'react';

export type FmToastTone = 'success' | 'warning' | 'error' | 'info';

export interface FmToastOptions {
  durationMs?: number;
  testId?: string;
}

export interface FmToastApi {
  success: (content: React.ReactNode, options?: FmToastOptions) => void;
  warning: (content: React.ReactNode, options?: FmToastOptions) => void;
  error: (content: React.ReactNode, options?: FmToastOptions) => void;
  info: (content: React.ReactNode, options?: FmToastOptions) => void;
}

export const FmToastContext = React.createContext<FmToastApi | null>(null);

export function useFmToast(): FmToastApi {
  const context = React.useContext(FmToastContext);
  if (!context) {
    throw new Error('useFmToast must be used within FmToastProvider');
  }
  return context;
}
